import { render, staticRenderFns } from "./SpecialAccess.vue?vue&type=template&id=15395eaa&"
import script from "./SpecialAccess.vue?vue&type=script&lang=ts&"
export * from "./SpecialAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports